import React from "react";
import ReactDOM from "react-dom";
import { formatMessage } from "lib/globalize-util";
import {
    DialogType,
    Dialog,
    DialogFooter,
    Button,
    ButtonGroup,
    Fabric,
    Theme,
    nuOrderTheme as theme,
} from "@nuorder/components";
import { DATATEST } from "constants/integration";
import { DialogTitle } from "../containers/space-manager/components/manage-access/dialog-title";

interface ICustomDialog {
    route?: string;
    title: string;
    message: string;
    onConfirm?: () => void;
}

interface ICustomDialogProps extends ICustomDialog {
    onClose: () => void;
}

let divContainer;
export const showCustomDialog = ({ route, title, message, onConfirm }: ICustomDialog): void => {
    const rootElement = document.getElementById("main-content");

    if (!divContainer) {
        divContainer = document.createElement("div");
    }

    const handleClose = () => {
        ReactDOM.unmountComponentAtNode(divContainer);
        divContainer = null;
    };

    const handleConfirm = () => {
        onConfirm && onConfirm();
        handleClose();
    };

    ReactDOM.render(
        <CustomDialogView
            route={route}
            title={title}
            message={message}
            onClose={handleClose}
            onConfirm={handleConfirm}
        />,
        rootElement.appendChild(divContainer)
    );
};

export const CustomDialogView: React.FunctionComponent<ICustomDialogProps> = ({
    title,
    message,
    onClose,
    onConfirm,
    route,
}) => {
    const dialogContentProps = React.useMemo(
        () => ({
            type: DialogType.normal,
            closeButtonAriaLabel: formatMessage("Close"),
            showCloseButton: true,
            title: <DialogTitle iconName="alertCircle24" mainTitle={title} iconColor={theme.palette.errorBase} />,
            subText: message,
            titleProps: {
                "data-test": DATATEST.FOLDERS.DIALOG.TITLE,
            } as any,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const modalProps = React.useMemo(
        () => ({
            titleAriaId: "dialogLabel",
            subtitleAriaId: "subTextLabel",
            styles: { main: { width: "400px !important", maxWidth: "100vw !important" } },
        }),
        []
    );

    return (
        <Theme>
            <Fabric>
                <Dialog
                    hidden={false}
                    dialogContentProps={dialogContentProps}
                    modalProps={modalProps}
                    onDismiss={onClose}
                >
                    <DialogFooter>
                        <ButtonGroup>
                            <Button
                                data-test={DATATEST.FOLDERS.DIALOG.CANCEL_BTN}
                                onClick={onClose}
                                text={formatMessage("No")}
                            />
                            {route ? (
                                <Button
                                    primary={true}
                                    href={route}
                                    target="_blank"
                                    data-test={DATATEST.FOLDERS.DIALOG.SAVE_BTN}
                                    onClick={onConfirm}
                                    text={formatMessage("Yes")}
                                />
                            ) : (
                                <Button
                                    primary={true}
                                    data-test={DATATEST.FOLDERS.DIALOG.SAVE_BTN}
                                    onClick={onConfirm}
                                    text={formatMessage("Yes")}
                                />
                            )}
                        </ButtonGroup>
                    </DialogFooter>
                </Dialog>
            </Fabric>
        </Theme>
    );
};
